import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-slate-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-display font-extrabold text-slate-900 text-lg">PM Poshan Calculator</div>
          <p className="mt-2 text-sm text-slate-600 leading-relaxed max-w-sm">
            A free tool for school HMs and teachers in Odisha to run the PM POSHAN mid-day meal
            programme — calculate quantities, track stock and generate reports in seconds.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-600 font-bold">Explore</div>
          <ul className="mt-3 space-y-2 text-sm text-slate-700">
            <li><Link className="hover:text-emerald-700" to="/about">About</Link></li>
            <li><Link className="hover:text-emerald-700" to="/faq">FAQ</Link></li>
            <li><Link className="hover:text-emerald-700" to="/premium">Premium ₹299 / year · Launch Offer</Link></li>
            <li><Link className="hover:text-emerald-700" to="/calculator">Calculator</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-orange-600 font-bold">Contact &amp; Legal</div>
          <p className="mt-3 text-sm text-slate-700 leading-relaxed">
            Email: <a href="mailto:TeacherUtilityToolKit@gmail.com" className="font-semibold text-emerald-700 hover:text-emerald-900">TeacherUtilityToolKit@gmail.com</a>
          </p>
          <ul className="mt-4 space-y-1 text-sm text-slate-700">
            <li><Link className="hover:text-emerald-700" to="/terms" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link className="hover:text-emerald-700" to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link className="hover:text-emerald-700" to="/refund" data-testid="footer-refund">Refund Policy</Link></li>
          </ul>
          <p className="mt-4 text-xs text-slate-500">
            Independent tool · not affiliated with the Government of India / Odisha.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-slate-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {new Date().getFullYear()} PM Poshan Calculator. A free independent tool for teachers &amp; MDM in-charges.</div>
          <div>Built for teachers · Runs on low-bandwidth Android</div>
        </div>
      </div>
    </footer>
  );
}
